import { render, staticRenderFns } from "./ChatbotPanel.vue?vue&type=template&id=d73c2d78"
import script from "./ChatbotPanel.vue?vue&type=script&lang=js"
export * from "./ChatbotPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports